module.exports = __webpack_public_path__ + "static/img/quanyouerweima.be5218f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/account/personal/testlive/quanyouerweima.jpg
// module id = RaKA
// module chunks = 1